import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=328dab26&scoped=true&"
import script from "./Navigate.vue?vue&type=script&lang=js&"
export * from "./Navigate.vue?vue&type=script&lang=js&"
import style0 from "./Navigate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Navigate.vue?vue&type=style&index=1&id=328dab26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dab26",
  null
  
)

export default component.exports